(() => {
    'use strict';

    if (window.__smLuxuryShopifyFormsV11) return;
    window.__smLuxuryShopifyFormsV11 = true;

    const styleKey = 'samson-mwita-luxury-forms-v11';
    const hostSelector = 'shopify-forms-embed, form-embed';

    const luxuryCss = String.raw`
      :host {
        --sm-black: #111111;
        --sm-white: #ffffff;
        --sm-field: #f6f6f4;
        --sm-field-hover: #f1f1ef;
        --sm-muted: #686868;
        --sm-error: #8b1e24;
        --sm-control-height: 50px;
        --sm-control-inset: 16px;

        --forms-body-font: normal 400 14px "Jost", Arial, sans-serif !important;
        --forms-heading-font: normal 500 34px "Jost", Arial, sans-serif !important;
        --forms-base-font-size: 14px !important;
        --forms-heading-font-size: 34px !important;
        --forms-base-font-line-height: 1.45 !important;

        --body-text-color: var(--sm-black) !important;
        --heading-text-color: var(--sm-black) !important;
        --form-text-color: var(--sm-black) !important;
        --form-placeholder-color: var(--sm-muted) !important;
        --form-background-color: var(--sm-field) !important;
        --container-background-color: var(--sm-white) !important;
        --form-error-color: var(--sm-error) !important;

        --forms-accent-color: var(--sm-black) !important;
        --forms-accent-color-hovered-modifier: var(--sm-black) !important;
        --link-text-color: var(--sm-black) !important;

        --button-background-color: var(--sm-black) !important;
        --button-text-color: var(--sm-white) !important;
        --button-background-color-hovered-modifier: none !important;
        --button-border: 1px solid var(--sm-black) !important;

        --form-field-border: inset 0 0 0 1px var(--sm-black) !important;
        --form-field-border-focused: inset 0 0 0 1px var(--sm-black) !important;
        --form-field-border-radius: 0 !important;
        --button-border-radius: 0 !important;
        --container-border-radius: 0 !important;

        --form-field-padding: var(--sm-control-inset) !important;
        --form-field-padding-top: 20px !important;
        --form-field-padding-bottom: 4px !important;
        --button-padding: 0 24px !important;
        --container-shadow: none !important;
        --container-max-w: 720px !important;
        --inline-container-max-width: 720px !important;

        --forms-padding-top: clamp(44px, 6vw, 66px) !important;
        --forms-padding-right: clamp(26px, 5vw, 54px) !important;
        --forms-padding-bottom: clamp(52px, 7vw, 74px) !important;
        --forms-padding-left: clamp(26px, 5vw, 54px) !important;

        --forms-focus-outline-width: 0px !important;
        --forms-focus-outline-color: var(--sm-black) !important;
        --forms-focus-outline-offset: 0px !important;
      }

      *,
      *::before,
      *::after {
        box-sizing: border-box;
      }

      /* Form frame */
      section:not([role='dialog']) > section[data-sizing='form-wrapper'] {
        width: 100% !important;
        max-width: 720px !important;
        border-top: 1px solid var(--sm-black) !important;
        border-bottom: 1px solid #dedede !important;
      }

      section[role='dialog'] > section[data-sizing='form-wrapper'] {
        max-width: 480px !important;
        border: 1px solid var(--sm-black) !important;
      }

      section[data-sizing='form-wrapper'],
      #form-container-ref[data-sizing='form-wrapper'] {
        background: var(--sm-white) !important;
        border-radius: 0 !important;
        box-shadow: none !important;
      }

      /* Header */
      section:has(> h2) {
        width: 100% !important;
        max-width: 600px !important;
        margin: 0 auto 38px !important;
      }

      h2 {
        margin: 0 !important;
        color: var(--sm-black) !important;
        font-family: "Jost", Arial, sans-serif !important;
        font-size: clamp(28px, 5vw, 38px) !important;
        font-style: normal !important;
        font-weight: 500 !important;
        line-height: 1.08 !important;
        letter-spacing: 0.055em !important;
        text-transform: uppercase !important;
        text-wrap: balance;
      }

      h2::after {
        content: '';
        display: block;
        width: 30px;
        height: 1px;
        margin: 19px auto 17px;
        background: var(--sm-black);
      }

      section:has(> h2) > div {
        max-width: 540px !important;
        margin-inline: auto !important;
        color: #454545 !important;
        font-family: "Jost", Arial, sans-serif !important;
        font-size: 14px !important;
        line-height: 1.65 !important;
        letter-spacing: 0.01em !important;
        text-wrap: pretty;
      }

      /* Form rhythm */
      form {
        width: 100% !important;
        max-width: 560px !important;
        margin-inline: auto !important;
        gap: 12px !important;
        padding-inline: 0 !important;
      }

      fieldset {
        min-width: 0 !important;
        margin: 10px 0 2px !important;
        padding: 0 !important;
        border: 0 !important;
      }

      fieldset > legend,
      form div[class*='_selectContainer_'] > p,
      form div:has(> button[aria-expanded]) > p {
        margin: 0 !important;
        padding: 0 0 8px !important;
        color: var(--sm-black) !important;
        font-family: "Jost", Arial, sans-serif !important;
        font-size: 11px !important;
        font-weight: 500 !important;
        line-height: 1.3 !important;
        letter-spacing: 0.14em !important;
        text-transform: uppercase !important;
      }

      /*
        Shopify's field container includes the input, floating label and error.
        It must remain content-sized; the visible black frame belongs only to
        the actual control.
      */
      form div[class*='_formFieldContainer_'] {
        position: relative !important;
        width: 100% !important;
        height: auto !important;
        min-height: 0 !important;
        max-height: none !important;
        margin: 0 !important;
        padding: 0 !important;
        overflow: visible !important;
        background: transparent !important;
        border: 0 !important;
        border-radius: 0 !important;
        outline: 0 !important;
        box-shadow: none !important;
      }

      /* Text, email, telephone and date controls */
      form input:not([type='checkbox']):not([type='radio']):not([type='hidden']):not([type='file']):not([type='submit']):not([type='button']):not([type='reset']) {
        -webkit-appearance: none !important;
        appearance: none !important;
        box-sizing: border-box !important;
        display: block !important;
        width: 100% !important;
        height: var(--sm-control-height) !important;
        min-height: var(--sm-control-height) !important;
        max-height: var(--sm-control-height) !important;
        margin: 0 !important;
        padding: 0 var(--sm-control-inset) !important;
        color: var(--sm-black) !important;
        background: var(--sm-field) !important;
        border: 0 !important;
        border-radius: 0 !important;
        outline: 0 !important;
        outline-offset: 0 !important;
        box-shadow: inset 0 0 0 1px var(--sm-black) !important;
        font-family: "Jost", Arial, sans-serif !important;
        font-size: 14px !important;
        font-weight: 400 !important;
        line-height: 1.2 !important;
        letter-spacing: 0.01em !important;
        text-align: left !important;
        transition: background-color 160ms ease !important;
      }

      form input:not([type='checkbox']):not([type='radio']):not([type='hidden']):not([type='file']):not([type='submit']):not([type='button']):not([type='reset']):hover {
        background: var(--sm-field-hover) !important;
      }

      form input:not([type='checkbox']):not([type='radio']):not([type='hidden']):not([type='file']):not([type='submit']):not([type='button']):not([type='reset']):focus,
      form input:not([type='checkbox']):not([type='radio']):not([type='hidden']):not([type='file']):not([type='submit']):not([type='button']):not([type='reset']):focus-visible {
        background: var(--sm-white) !important;
        border: 0 !important;
        outline: 0 !important;
        outline-offset: 0 !important;
        box-shadow: inset 0 0 0 1px var(--sm-black) !important;
      }

      /* One clean prompt inset for empty, focused and filled fields. */
      form label[id^='label-'] {
        position: absolute !important;
        z-index: 1 !important;
        top: calc(var(--sm-control-height) / 2) !important;
        bottom: auto !important;
        left: var(--sm-control-inset) !important;
        right: auto !important;
        width: auto !important;
        max-width: calc(100% - (var(--sm-control-inset) * 2)) !important;
        margin: 0 !important;
        padding: 0 !important;
        color: var(--sm-muted) !important;
        font-family: "Jost", Arial, sans-serif !important;
        font-size: 13px !important;
        font-weight: 400 !important;
        line-height: 1 !important;
        letter-spacing: 0.055em !important;
        text-transform: uppercase !important;
        transform: translateY(-50%) !important;
        transform-origin: left top !important;
        pointer-events: none !important;
      }

      form input:focus + label[id^='label-'],
      form input[type='tel'] + label[id^='label-'],
      form input:is(:autofill, :-webkit-autofill) + label[id^='label-'],
      form label[id^='label-'][class*='_inputFilled_'] {
        top: 7px !important;
        font-size: 10px !important;
        line-height: 1 !important;
        transform: none !important;
      }

      /* Match the base control's specificity in every floating-label state.
         Otherwise a filled field loses its inset as soon as focus leaves it. */
      form input:not([type='checkbox']):not([type='radio']):not([type='hidden']):not([type='file']):not([type='submit']):not([type='button']):not([type='reset']):is(:focus, [type='tel'], :has(+ label[id^='label-'][class*='_inputFilled_']), :autofill, :-webkit-autofill) {
        padding: 20px var(--sm-control-inset) 4px !important;
      }

      form input:-webkit-autofill {
        -webkit-text-fill-color: var(--sm-black) !important;
        -webkit-box-shadow: inset 0 0 0 1000px var(--sm-field) !important;
      }

      /* Phone row */
      form div[class*='_formPhoneInputContainer_'],
      form div:has(> .phone-country-selector) {
        display: grid !important;
        grid-template-columns: 78px minmax(0, 1fr) !important;
        align-items: start !important;
        width: 100% !important;
        height: auto !important;
        min-height: 0 !important;
        margin: 0 !important;
        padding: 0 !important;
        gap: 8px !important;
        overflow: visible !important;
        background: transparent !important;
        border: 0 !important;
        outline: 0 !important;
        box-shadow: none !important;
      }

      form .phone-country-selector,
      form .phone-country-selector > div {
        width: 100% !important;
        height: var(--sm-control-height) !important;
        min-height: var(--sm-control-height) !important;
        max-height: var(--sm-control-height) !important;
        margin: 0 !important;
      }

      form button[type='button'][aria-expanded] {
        box-sizing: border-box !important;
        display: flex !important;
        align-items: center !important;
        justify-content: space-between !important;
        width: 100% !important;
        height: var(--sm-control-height) !important;
        min-height: var(--sm-control-height) !important;
        max-height: var(--sm-control-height) !important;
        margin: 0 !important;
        padding: 0 var(--sm-control-inset) !important;
        color: var(--sm-black) !important;
        background: var(--sm-field) !important;
        border: 0 !important;
        border-radius: 0 !important;
        outline: 0 !important;
        outline-offset: 0 !important;
        box-shadow: inset 0 0 0 1px var(--sm-black) !important;
        font-family: "Jost", Arial, sans-serif !important;
        font-size: 14px !important;
        font-weight: 400 !important;
        line-height: 1.2 !important;
        letter-spacing: 0.01em !important;
        transition: background-color 160ms ease !important;
      }

      form button[type='button'][aria-expanded]:hover {
        background: var(--sm-field-hover) !important;
      }

      form button[type='button'][aria-expanded]:focus,
      form button[type='button'][aria-expanded]:focus-visible {
        background: var(--sm-white) !important;
        border: 0 !important;
        outline: 0 !important;
        outline-offset: 0 !important;
        box-shadow: inset 0 0 0 1px var(--sm-black) !important;
      }

      form .phone-country-selector button[type='button'][aria-expanded] {
        padding-inline: 14px !important;
      }

      form .phone-country-selector img[class*='_flagIcon_'] {
        width: 23px !important;
        height: 17px !important;
        object-fit: cover !important;
      }

      form button[type='button'][aria-expanded] svg path {
        fill: var(--sm-black) !important;
      }

      form div[class*='_formPhoneInputContainer_'] > output,
      form div:has(> .phone-country-selector) > output {
        grid-column: 1 / -1 !important;
      }

      /* Birthday */
      form [data-testid='date-birthday'] {
        width: 100% !important;
        margin: 4px 0 0 !important;
      }

      form [data-testid='date-birthday'] > div:first-child {
        margin: 0 !important;
        padding: 0 0 8px !important;
        color: var(--sm-black) !important;
        font-family: "Jost", Arial, sans-serif !important;
        font-size: 11px !important;
        font-weight: 500 !important;
        line-height: 1.3 !important;
        letter-spacing: 0.14em !important;
        text-transform: uppercase !important;
      }

      form [data-testid='date-birthday'] > div:nth-child(2) {
        display: grid !important;
        grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 2fr) !important;
        width: 100% !important;
        gap: 8px !important;
      }

      /* Textarea */
      form textarea {
        box-sizing: border-box !important;
        display: block !important;
        width: 100% !important;
        min-height: 104px !important;
        margin: 0 !important;
        padding: 24px var(--sm-control-inset) 12px !important;
        color: var(--sm-black) !important;
        background: var(--sm-field) !important;
        border: 0 !important;
        border-radius: 0 !important;
        outline: 0 !important;
        outline-offset: 0 !important;
        box-shadow: inset 0 0 0 1px var(--sm-black) !important;
        font-family: "Jost", Arial, sans-serif !important;
        font-size: 14px !important;
        font-weight: 400 !important;
        line-height: 1.5 !important;
        resize: vertical !important;
      }

      form textarea:focus,
      form textarea:focus-visible {
        background: var(--sm-white) !important;
        outline: 0 !important;
        box-shadow: inset 0 0 0 1px var(--sm-black) !important;
      }

      /*
        Multi-choice tiles use two permanent columns. Shopify briefly reapplies
        its native input class after a click; these locked grid areas prevent
        that delayed rerender from pushing the label over the checkbox.
      */
      fieldset > div:has(> label:nth-of-type(2)) {
        display: grid !important;
        grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
        align-items: stretch !important;
        gap: 8px !important;
      }

      fieldset > div:has(> label:nth-of-type(2)) > label,
      [data-sm-choice-tile] {
        position: relative !important;
        display: grid !important;
        grid-template-columns: 17px minmax(0, 1fr) !important;
        grid-template-rows: minmax(0, 1fr) !important;
        grid-auto-flow: row !important;
        align-items: center !important;
        justify-items: stretch !important;
        width: 100% !important;
        min-width: 0 !important;
        min-height: 48px !important;
        margin: 0 !important;
        padding: 8px 13px !important;
        column-gap: 11px !important;
        row-gap: 0 !important;
        overflow: hidden !important;
        isolation: isolate !important;
        color: var(--sm-black) !important;
        background: var(--sm-white) !important;
        border: 1px solid #d6d6d6 !important;
        border-radius: 0 !important;
        outline: 0 !important;
        box-shadow: none !important;
        cursor: pointer !important;
        transition: color 140ms ease, background-color 140ms ease, border-color 140ms ease !important;
      }

      fieldset > div:has(> label:nth-of-type(2)) > label:hover,
      [data-sm-choice-tile]:hover {
        background: var(--sm-field) !important;
        border-color: #777777 !important;
      }

      fieldset > div:has(> label:nth-of-type(2)) > label:has(input:checked),
      [data-sm-choice-tile][data-sm-selected] {
        color: var(--sm-white) !important;
        background: var(--sm-black) !important;
        border-color: var(--sm-black) !important;
      }

      fieldset > div:has(> label:nth-of-type(2)) > label:has(input:focus-visible),
      [data-sm-choice-tile]:has([data-sm-choice-control]:focus-visible) {
        border-color: var(--sm-black) !important;
        outline: 0 !important;
        box-shadow: inset 0 0 0 1px var(--sm-black) !important;
      }

      form fieldset [data-sm-choice-tile] > [data-sm-choice-copy],
      fieldset > div:has(> label:nth-of-type(2)) > label > span,
      [data-sm-choice-copy] {
        position: static !important;
        inset: auto !important;
        grid-column: 2 !important;
        grid-row: 1 !important;
        align-self: center !important;
        justify-self: stretch !important;
        display: block !important;
        min-width: 0 !important;
        width: auto !important;
        height: auto !important;
        margin: 0 !important;
        padding: 0 !important;
        overflow-wrap: anywhere !important;
        color: inherit !important;
        font-family: "Jost", Arial, sans-serif !important;
        font-size: 13.5px !important;
        font-weight: 400 !important;
        line-height: 1.35 !important;
        letter-spacing: 0.01em !important;
        text-align: left !important;
        transform: none !important;
        pointer-events: none !important;
        transition: color 140ms ease !important;
      }

      [data-sm-choice-control-cell] {
        position: static !important;
        inset: auto !important;
        grid-column: 1 !important;
        grid-row: 1 !important;
        align-self: center !important;
        justify-self: center !important;
        display: grid !important;
        place-items: center !important;
        flex: 0 0 17px !important;
        width: 17px !important;
        min-width: 17px !important;
        max-width: 17px !important;
        height: 17px !important;
        min-height: 17px !important;
        max-height: 17px !important;
        margin: 0 !important;
        padding: 0 !important;
        overflow: visible !important;
        background: transparent !important;
        border: 0 !important;
        outline: 0 !important;
        box-shadow: none !important;
        transform: none !important;
      }

      input[type='checkbox'],
      input[type='radio'] {
        -webkit-appearance: none !important;
        appearance: none !important;
        box-sizing: border-box !important;
        position: static !important;
        inset: auto !important;
        display: block !important;
        grid-column: 1 !important;
        grid-row: 1 !important;
        align-self: center !important;
        justify-self: center !important;
        flex: 0 0 17px !important;
        width: 17px !important;
        min-width: 17px !important;
        max-width: 17px !important;
        height: 17px !important;
        min-height: 17px !important;
        max-height: 17px !important;
        inline-size: 17px !important;
        block-size: 17px !important;
        aspect-ratio: 1 / 1 !important;
        margin: 0 !important;
        padding: 0 !important;
        overflow: visible !important;
        opacity: 1 !important;
        visibility: visible !important;
        clip: auto !important;
        clip-path: none !important;
        background: var(--sm-white) !important;
        border: 1px solid #696969 !important;
        outline: 0 !important;
        box-shadow: none !important;
        transform: none !important;
        translate: none !important;
        scale: none !important;
        cursor: pointer !important;
        transition: none !important;
        animation: none !important;
      }

      form fieldset [data-sm-choice-tile] [data-sm-choice-control],
      form fieldset > div:has(> label:nth-of-type(2)) > label > input[type='checkbox'],
      form fieldset > div:has(> label:nth-of-type(2)) > label > input[type='radio'] {
        position: static !important;
        inset: auto !important;
        display: block !important;
        grid-column: 1 !important;
        grid-row: 1 !important;
        align-self: center !important;
        justify-self: center !important;
        flex: 0 0 17px !important;
        width: 17px !important;
        min-width: 17px !important;
        max-width: 17px !important;
        height: 17px !important;
        min-height: 17px !important;
        max-height: 17px !important;
        inline-size: 17px !important;
        block-size: 17px !important;
        margin: 0 !important;
        padding: 0 !important;
        transform: none !important;
        transition: none !important;
      }

      /*
        Floating-label padding must never reach a choice control. Keep every
        mouse, keyboard and pressed state at exactly the same 17px geometry.
      */
      form fieldset [data-sm-choice-tile] input:is(:focus, :focus-visible, :active),
      form fieldset > div:has(> label:nth-of-type(2)) > label input:is(:focus, :focus-visible, :active) {
        box-sizing: border-box !important;
        width: 17px !important;
        min-width: 17px !important;
        max-width: 17px !important;
        height: 17px !important;
        min-height: 17px !important;
        max-height: 17px !important;
        inline-size: 17px !important;
        block-size: 17px !important;
        margin: 0 !important;
        padding: 0 !important;
        outline: 0 !important;
        transform: none !important;
      }

      input[type='checkbox'] {
        border-radius: 0 !important;
      }

      input[type='radio'] {
        border-radius: 50% !important;
      }

      input[type='checkbox']:checked,
      input[type='radio']:checked {
        background: var(--sm-black) !important;
        border-color: var(--sm-black) !important;
        box-shadow: inset 0 0 0 2px var(--sm-white) !important;
      }

      fieldset > div:has(> label:nth-of-type(2)) > label:has(input:checked) input,
      [data-sm-choice-tile][data-sm-selected] [data-sm-choice-control] {
        background: var(--sm-white) !important;
        border-color: var(--sm-white) !important;
        box-shadow: inset 0 0 0 2px var(--sm-black) !important;
      }

      input[type='checkbox']:focus-visible,
      input[type='radio']:focus-visible {
        outline: 0 !important;
        border-color: var(--sm-black) !important;
        box-shadow: inset 0 0 0 1px var(--sm-black) !important;
      }

      /* Select menus */
      [role='listbox'] {
        padding: 6px !important;
        color: var(--sm-black) !important;
        background: var(--sm-white) !important;
        border: 1px solid var(--sm-black) !important;
        border-radius: 0 !important;
        outline: 0 !important;
        box-shadow: 0 18px 40px rgb(0 0 0 / 12%) !important;
      }

      [role='option'] {
        padding: 9px 11px !important;
        border-radius: 0 !important;
        font-family: "Jost", Arial, sans-serif !important;
        font-size: 13px !important;
        line-height: 1.35 !important;
      }

      [role='option'][aria-selected='true'],
      [role='option']:hover,
      [role='option']:focus-visible {
        color: var(--sm-white) !important;
        background: var(--sm-black) !important;
        outline: 0 !important;
      }

      /* Submit */
      form button[type='submit'][data-testid='btn-form-submit'],
      form > button[type='submit'] {
        box-sizing: border-box !important;
        display: inline-flex !important;
        align-self: center !important;
        align-items: center !important;
        justify-content: center !important;
        width: 100% !important;
        max-width: 500px !important;
        height: 52px !important;
        min-height: 52px !important;
        margin: 20px auto 0 !important;
        padding: 0 24px !important;
        color: var(--sm-white) !important;
        background: var(--sm-black) !important;
        border: 1px solid var(--sm-black) !important;
        border-radius: 0 !important;
        outline: 0 !important;
        outline-offset: 0 !important;
        box-shadow: none !important;
        filter: none !important;
        font-family: "Jost", Arial, sans-serif !important;
        font-size: 11.5px !important;
        font-weight: 500 !important;
        line-height: 1 !important;
        letter-spacing: 0.18em !important;
        text-align: center !important;
        text-transform: uppercase !important;
        white-space: nowrap !important;
        transition: color 160ms ease, background-color 160ms ease !important;
      }

      form button[type='submit'] > span,
      form button[type='submit'] > div {
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        width: auto !important;
        height: auto !important;
        margin: 0 !important;
        padding: 0 !important;
        line-height: 1 !important;
        text-align: center !important;
        transform: none !important;
      }

      form button[type='submit']:hover,
      form button[type='submit']:focus-visible {
        color: var(--sm-black) !important;
        background: var(--sm-white) !important;
        border-color: var(--sm-black) !important;
        outline: 0 !important;
        box-shadow: inset 0 0 0 1px var(--sm-black) !important;
        filter: none !important;
      }

      form button[type='submit']:disabled {
        color: var(--sm-white) !important;
        background: var(--sm-black) !important;
        opacity: 0.48 !important;
      }

      /* Popup teaser */
      button[data-testid='form-teaser'] {
        padding: 15px 19px !important;
        color: var(--sm-white) !important;
        background: var(--sm-black) !important;
        border: 1px solid var(--sm-black) !important;
        border-radius: 0 !important;
        box-shadow: none !important;
        font-family: "Jost", Arial, sans-serif !important;
        font-size: 11px !important;
        font-weight: 500 !important;
        letter-spacing: 0.15em !important;
        text-transform: uppercase !important;
      }

      /* Supporting copy and validation */
      a {
        color: var(--sm-black) !important;
        text-decoration-thickness: 1px !important;
        text-underline-offset: 4px !important;
      }

      form > div:has(a) {
        color: #555555 !important;
        font-family: "Jost", Arial, sans-serif !important;
        font-size: 11px !important;
        line-height: 1.55 !important;
        letter-spacing: 0.01em !important;
      }

      output[role='alert'] {
        margin-top: 6px !important;
        color: var(--sm-error) !important;
        font-family: "Jost", Arial, sans-serif !important;
        font-size: 11.5px !important;
        line-height: 1.45 !important;
        letter-spacing: 0.02em !important;
      }

      @media (max-width: 600px) {
        :host {
          --sm-control-height: 48px;
          --sm-control-inset: 14px;
          --forms-padding-top: 36px !important;
          --forms-padding-right: 18px !important;
          --forms-padding-bottom: 50px !important;
          --forms-padding-left: 18px !important;
        }

        section:has(> h2) {
          margin-bottom: 32px !important;
        }

        h2 {
          font-size: clamp(25px, 8vw, 31px) !important;
          letter-spacing: 0.045em !important;
        }

        form {
          gap: 11px !important;
        }

        form div[class*='_formPhoneInputContainer_'],
        form div:has(> .phone-country-selector) {
          grid-template-columns: 70px minmax(0, 1fr) !important;
          gap: 6px !important;
        }

        form [data-testid='date-birthday'] > div:nth-child(2) {
          grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1.55fr) !important;
          gap: 6px !important;
        }

        fieldset > div:has(> label:nth-of-type(2)) {
          grid-template-columns: 1fr !important;
          gap: 7px !important;
        }

        fieldset > div:has(> label:nth-of-type(2)) > label,
        [data-sm-choice-tile] {
          min-height: 46px !important;
          padding: 8px 12px !important;
          gap: 10px !important;
        }

        form button[type='submit'][data-testid='btn-form-submit'],
        form > button[type='submit'] {
          height: 50px !important;
          min-height: 50px !important;
        }
      }

      /* ================================================================
         NEWSLETTER OVERLAY ONLY
         JavaScript marks the live modal nodes directly. This avoids relying
         on Shopify's changing overlay wrapper while leaving inline forms
         completely untouched.
         ================================================================ */

      [data-sm-newsletter-root] {
        box-sizing: border-box !important;
        width: 100% !important;
        height: 100% !important;
        padding: 24px !important;
      }

      [data-sm-newsletter-container] {
        --sm-control-height: 46px;
        --sm-control-inset: 14px;

        box-sizing: border-box !important;
        display: grid !important;
        width: min(420px, calc(100vw - 48px)) !important;
        height: auto !important;
        min-width: 0 !important;
        max-width: 420px !important;
        max-height: min(600px, calc(100vh - 48px)) !important;
        max-height: min(600px, calc(100dvh - 48px)) !important;
        grid-template-columns: minmax(0, 1fr) !important;
        grid-template-rows: minmax(0, auto) !important;
        grid-template-areas: 'content' !important;
        overflow: hidden !important;
        background: var(--sm-white) !important;
        border: 1px solid var(--sm-black) !important;
        border-radius: 0 !important;
        box-shadow: none !important;
      }

      [data-sm-newsletter-container][data-sm-newsletter-has-image] {
        width: min(760px, calc(100vw - 48px)) !important;
        max-width: 760px !important;
        grid-template-columns: minmax(0, 420px) minmax(0, 340px) !important;
        grid-template-areas: 'content image' !important;
      }

      [data-sm-newsletter-content] {
        box-sizing: border-box !important;
        grid-area: content !important;
        min-width: 0 !important;
        min-height: 0 !important;
        max-height: min(598px, calc(100vh - 50px)) !important;
        max-height: min(598px, calc(100dvh - 50px)) !important;
        padding: 38px 38px 30px !important;
        overflow-x: hidden !important;
        overflow-y: auto !important;
        scrollbar-width: thin;
      }

      [data-sm-newsletter-image] {
        box-sizing: border-box !important;
        display: block !important;
        grid-area: image !important;
        width: 100% !important;
        height: 100% !important;
        min-width: 0 !important;
        min-height: 0 !important;
        overflow: hidden !important;
        background-color: #f3f2ef !important;
        background-position: center center !important;
        background-repeat: no-repeat !important;
        background-size: contain !important;
      }

      [data-sm-newsletter-image-media] {
        background-color: #f3f2ef !important;
        background-position: center center !important;
        background-repeat: no-repeat !important;
        background-size: contain !important;
      }

      [data-sm-newsletter-image] :is(picture, img),
      [data-sm-newsletter-image-media] :is(picture, img),
      :is(picture, img)[data-sm-newsletter-image],
      :is(picture, img)[data-sm-newsletter-image-media] {
        box-sizing: border-box !important;
        display: block !important;
        width: 100% !important;
        height: 100% !important;
        max-width: 100% !important;
        max-height: 100% !important;
      }

      [data-sm-newsletter-image] img,
      [data-sm-newsletter-image-media] img,
      img[data-sm-newsletter-image],
      img[data-sm-newsletter-image-media] {
        object-fit: contain !important;
        object-position: center center !important;
      }

      [data-sm-newsletter-content] section:has(> h2) {
        width: 100% !important;
        max-width: 344px !important;
        margin: 0 auto 20px !important;
        text-align: center !important;
      }

      [data-sm-newsletter-heading] {
        box-sizing: border-box !important;
        display: flex !important;
        width: 100% !important;
        max-width: 330px !important;
        margin: 0 auto !important;
        padding: 0 !important;
        flex-direction: column !important;
        align-items: center !important;
        color: var(--sm-black) !important;
        font-family: "Jost", Arial, sans-serif !important;
        font-size: clamp(27px, 2.25vw, 31px) !important;
        font-style: normal !important;
        font-weight: 500 !important;
        line-height: 1.02 !important;
        letter-spacing: 0.045em !important;
        text-align: center !important;
        text-indent: 0 !important;
        text-transform: uppercase !important;
        white-space: normal !important;
      }

      [data-sm-newsletter-heading] > [data-sm-newsletter-line] {
        display: block !important;
        width: max-content !important;
        max-width: 100% !important;
        margin-inline: auto !important;
        text-align: center !important;
      }

      [data-sm-newsletter-heading]::after {
        width: 26px !important;
        margin: 14px auto 11px !important;
      }

      [data-sm-newsletter-content] section:has(> h2) > div {
        max-width: 326px !important;
        margin-inline: auto !important;
        font-size: 13px !important;
        line-height: 1.55 !important;
        text-align: center !important;
      }

      [data-sm-newsletter-content] form {
        width: 100% !important;
        max-width: 344px !important;
        margin-inline: auto !important;
        gap: 9px !important;
      }

      [data-sm-newsletter-content]
        :is(input, select, textarea):not([type='checkbox']):not([type='radio']) {
        min-height: 46px !important;
      }

      [data-sm-newsletter-content]
        form button[type='submit'][data-testid='btn-form-submit'],
      [data-sm-newsletter-content]
        form > button[type='submit'] {
        width: 100% !important;
        max-width: 344px !important;
        height: 46px !important;
        min-height: 46px !important;
        margin-top: 13px !important;
        padding-inline: 18px !important;
        font-size: 11px !important;
        letter-spacing: 0.17em !important;
      }

      [data-sm-newsletter-content] form > div:has(a) {
        margin-top: 3px !important;
        font-size: 10px !important;
        line-height: 1.45 !important;
      }

      [data-sm-newsletter-close-wrapper] {
        top: 16px !important;
        right: 16px !important;
      }

      [data-sm-newsletter-close] {
        display: grid !important;
        place-items: center !important;
        width: 32px !important;
        height: 32px !important;
        padding: 0 !important;
        background: var(--sm-white) !important;
        border: 1px solid rgb(17 17 17 / 14%) !important;
        border-radius: 50% !important;
      }

      [data-sm-newsletter-close] svg {
        width: 11px !important;
        height: 11px !important;
        fill: var(--sm-black) !important;
        fill-opacity: 1 !important;
      }

      @media (max-width: 820px) {
        [data-sm-newsletter-root] {
          padding: 12px !important;
        }

        [data-sm-newsletter-container],
        [data-sm-newsletter-container][data-sm-newsletter-has-image] {
          --sm-control-height: 44px;
          --sm-control-inset: 14px;

          width: min(100%, 410px) !important;
          max-width: 410px !important;
          max-height: calc(100vh - 24px) !important;
          max-height: calc(100dvh - 24px) !important;
          grid-template-columns: minmax(0, 1fr) !important;
          grid-template-areas: 'content' !important;
        }

        [data-sm-newsletter-image] {
          display: none !important;
        }

        [data-sm-newsletter-content] {
          max-height: calc(100vh - 26px) !important;
          max-height: calc(100dvh - 26px) !important;
          padding: 30px 22px 22px !important;
        }

        [data-sm-newsletter-heading] {
          max-width: 300px !important;
          font-size: clamp(24px, 6.7vw, 27px) !important;
        }

        [data-sm-newsletter-content] form {
          max-width: 336px !important;
          gap: 8px !important;
        }

        [data-sm-newsletter-content]
          form button[type='submit'][data-testid='btn-form-submit'],
        [data-sm-newsletter-content]
          form > button[type='submit'] {
          max-width: 336px !important;
          height: 44px !important;
          min-height: 44px !important;
          margin-top: 11px !important;
        }

        [data-sm-newsletter-close-wrapper] {
          top: 13px !important;
          right: 13px !important;
        }
      }

      @media (max-width: 420px) {
        [data-sm-newsletter-root] {
          padding: 8px !important;
        }

        [data-sm-newsletter-container],
        [data-sm-newsletter-container][data-sm-newsletter-has-image] {
          width: 100% !important;
          max-width: 100% !important;
          max-height: calc(100vh - 16px) !important;
          max-height: calc(100dvh - 16px) !important;
        }

        [data-sm-newsletter-content] {
          max-height: calc(100vh - 18px) !important;
          max-height: calc(100dvh - 18px) !important;
          padding: 28px 18px 20px !important;
        }

        [data-sm-newsletter-heading] {
          max-width: 270px !important;
          font-size: clamp(22px, 7.2vw, 25px) !important;
        }
      }

      /*
        Final newsletter geometry. The doubled marker selectors deliberately
        outrank Shopify Forms' modal sizing without changing inline forms.
        The 8:5 card ratio gives each half a 4:5 image area, matching the
        newsletter artwork and eliminating both cropping and letterboxing.
      */
      :host [data-sm-newsletter-container][data-sm-newsletter-container] {
        --sm-control-height: 44px;
        --sm-control-inset: 14px;

        display: grid !important;
        width: min(420px, calc(100vw - 48px)) !important;
        height: auto !important;
        min-width: 0 !important;
        min-height: 0 !important;
        max-width: 420px !important;
        max-height: calc(100vh - 48px) !important;
        max-height: calc(100dvh - 48px) !important;
        aspect-ratio: auto !important;
        grid-template-columns: minmax(0, 1fr) !important;
        grid-template-rows: minmax(0, auto) !important;
        grid-template-areas: 'content' !important;
        overflow: hidden !important;
      }

      :host
        [data-sm-newsletter-container][data-sm-newsletter-container]
        [data-sm-newsletter-content][data-sm-newsletter-content] {
        width: 100% !important;
        height: auto !important;
        min-width: 0 !important;
        min-height: 0 !important;
        max-height: calc(100vh - 50px) !important;
        max-height: calc(100dvh - 50px) !important;
        padding: 30px 36px 22px !important;
        overflow-x: hidden !important;
        overflow-y: auto !important;
      }

      :host
        [data-sm-newsletter-content][data-sm-newsletter-content]
        section:has(> [data-sm-newsletter-heading]) {
        width: 100% !important;
        max-width: 352px !important;
        margin: 0 auto 14px !important;
        text-align: center !important;
      }

      :host [data-sm-newsletter-heading][data-sm-newsletter-heading] {
        display: flex !important;
        width: 100% !important;
        max-width: 340px !important;
        margin: 0 auto !important;
        padding: 0 !important;
        flex-direction: column !important;
        align-items: center !important;
        font-size: clamp(25px, 2vw, 28px) !important;
        font-weight: 500 !important;
        line-height: 1.01 !important;
        letter-spacing: 0.035em !important;
        text-align: center !important;
        text-indent: 0 !important;
        white-space: normal !important;
        overflow: visible !important;
      }

      :host
        [data-sm-newsletter-heading][data-sm-newsletter-heading]
        > [data-sm-newsletter-line] {
        display: block !important;
        width: auto !important;
        max-width: 100% !important;
        margin: 0 auto !important;
        text-align: center !important;
        white-space: nowrap !important;
      }

      :host
        [data-sm-newsletter-heading][data-sm-newsletter-heading]::after {
        width: 26px !important;
        margin: 12px auto 9px !important;
      }

      :host
        [data-sm-newsletter-content][data-sm-newsletter-content]
        section:has(> [data-sm-newsletter-heading])
        > div {
        max-width: 330px !important;
        margin-inline: auto !important;
        font-size: 12.5px !important;
        line-height: 1.48 !important;
        text-align: center !important;
      }

      :host
        [data-sm-newsletter-content][data-sm-newsletter-content]
        form {
        width: 100% !important;
        max-width: 352px !important;
        margin-inline: auto !important;
        gap: 8px !important;
      }

      :host
        [data-sm-newsletter-content][data-sm-newsletter-content]
        :is(input, select, textarea):not([type='checkbox']):not([type='radio']) {
        height: 44px !important;
        min-height: 44px !important;
      }

      :host
        [data-sm-newsletter-content][data-sm-newsletter-content]
        form button[type='submit'] {
        display: flex !important;
        width: 100% !important;
        max-width: 352px !important;
        height: 44px !important;
        min-height: 44px !important;
        margin-top: 10px !important;
        padding: 0 16px !important;
        align-items: center !important;
        justify-content: center !important;
        font-size: 10px !important;
        line-height: 1 !important;
        letter-spacing: 0.13em !important;
        text-align: center !important;
        text-indent: 0 !important;
        white-space: nowrap !important;
        overflow: hidden !important;
      }

      :host
        [data-sm-newsletter-content][data-sm-newsletter-content]
        form > div:has(a) {
        max-width: 318px !important;
        margin: 2px auto 0 !important;
        font-size: 9px !important;
        line-height: 1.4 !important;
        text-align: center !important;
      }

      @media (min-width: 821px) {
        :host
          [data-sm-newsletter-container][data-sm-newsletter-container]
          [data-sm-newsletter-image][data-sm-newsletter-image] {
          display: block !important;
          width: 100% !important;
          height: 100% !important;
          min-width: 0 !important;
          min-height: 0 !important;
          background-color: #f3f2ef !important;
          background-position: center center !important;
          background-repeat: no-repeat !important;
          background-size: cover !important;
          overflow: hidden !important;
        }

        :host
          [data-sm-newsletter-container][data-sm-newsletter-container]
          [data-sm-newsletter-image-media][data-sm-newsletter-image-media] {
          width: 100% !important;
          height: 100% !important;
          background-color: #f3f2ef !important;
          background-position: center center !important;
          background-repeat: no-repeat !important;
          background-size: cover !important;
        }

        :host
          [data-sm-newsletter-container][data-sm-newsletter-container]
          [data-sm-newsletter-image]
          img,
        :host
          [data-sm-newsletter-container][data-sm-newsletter-container]
          img[data-sm-newsletter-image-media] {
          width: 100% !important;
          height: 100% !important;
          object-fit: cover !important;
          object-position: center center !important;
        }

        :host
          [data-sm-newsletter-container][data-sm-newsletter-container][data-sm-newsletter-has-image] {
          width: min(880px, calc(100vw - 48px), calc(160vh - 77px)) !important;
          width: min(880px, calc(100vw - 48px), calc(160dvh - 77px)) !important;
          height: auto !important;
          min-height: 0 !important;
          max-width: 880px !important;
          max-height: none !important;
          aspect-ratio: 8 / 5 !important;
          grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) !important;
          grid-template-rows: minmax(0, 1fr) !important;
          grid-template-areas: 'content image' !important;
        }

        :host
          [data-sm-newsletter-container][data-sm-newsletter-container]
          [data-sm-newsletter-content][data-sm-newsletter-content] {
          width: 100% !important;
          height: 100% !important;
          max-height: none !important;
          padding: clamp(22px, 3.4vh, 30px) 36px 21px !important;
        }
      }

      @media (max-width: 820px) {
        :host [data-sm-newsletter-root][data-sm-newsletter-root] {
          padding: 12px !important;
        }

        :host [data-sm-newsletter-container][data-sm-newsletter-container],
        :host
          [data-sm-newsletter-container][data-sm-newsletter-container][data-sm-newsletter-has-image] {
          width: min(410px, calc(100vw - 24px)) !important;
          height: auto !important;
          max-width: 410px !important;
          max-height: calc(100vh - 24px) !important;
          max-height: calc(100dvh - 24px) !important;
          aspect-ratio: auto !important;
          grid-template-columns: minmax(0, 1fr) !important;
          grid-template-rows: minmax(0, auto) !important;
          grid-template-areas: 'content' !important;
        }

        :host
          [data-sm-newsletter-container][data-sm-newsletter-container]
          [data-sm-newsletter-image][data-sm-newsletter-image] {
          display: none !important;
        }

        :host
          [data-sm-newsletter-container][data-sm-newsletter-container]
          [data-sm-newsletter-content][data-sm-newsletter-content] {
          width: 100% !important;
          height: auto !important;
          max-height: calc(100vh - 26px) !important;
          max-height: calc(100dvh - 26px) !important;
          padding: 30px 24px 22px !important;
        }

        :host [data-sm-newsletter-heading][data-sm-newsletter-heading] {
          max-width: 300px !important;
          font-size: clamp(23px, 6.5vw, 26px) !important;
        }
      }

      @media (prefers-reduced-motion: reduce) {
        *,
        *::before,
        *::after {
          scroll-behavior: auto !important;
          transition: none !important;
          animation: none !important;
        }
      }
    `;

    /*
      Register V11 before Shopify creates a form host. Delete every earlier
      Samson Mwita generation so a new host never adopts competing builds.
    */
    const formStyles = window.formStyles instanceof Map
      ? window.formStyles
      : new Map();

    Array.from(formStyles.keys()).forEach((key) => {
      if (
        typeof key === 'string' &&
        key.startsWith('samson-mwita-luxury-forms-')
      ) {
        formStyles.delete(key);
      }
    });

    formStyles.set(styleKey, luxuryCss);
    window.formStyles = formStyles;

    let luxurySheet = null;

    let sheetAttempted = false;
    const prepareSheet = () => {
      if (sheetAttempted) return;
      sheetAttempted = true;
      try {
        luxurySheet = new CSSStyleSheet();
        luxurySheet.replaceSync(luxuryCss);
      } catch (_) { luxurySheet = null; }
    };

    const styledRoots = new WeakSet();
    const observedRoots = new WeakSet();
    const choiceInputSelector =
      "fieldset input[type='checkbox'], fieldset input[type='radio']";
    const newsletterCloseSelector = [
      "[data-testid='btn-close']",
      "button[aria-label*='close' i]",
      "button[title*='close' i]"
    ].join(',');
    const newsletterStructureSelector = [
      'form', 'h2', 'style', "link[rel='stylesheet']", "[role='dialog']", "[aria-modal='true']",
      'img', 'picture', "[data-testid='image']", "[style*='background-image']",
      newsletterCloseSelector
    ].join(',');
    const mark = (element, attribute) => {
      if (element && !element.hasAttribute(attribute)) element.setAttribute(attribute, '');
    };
    const legacyMarkerSelector = [
      '[data-sm-field-shell]',
      '[data-sm-field-layer]',
      '[data-sm-control-row]',
      '[data-sm-prompt]',
      '[data-sm-control]'
    ].join(',');

    const clearLegacyMarkers = (root) => {
      root.querySelectorAll(legacyMarkerSelector).forEach((element) => {
        [
          'data-sm-field-shell',
          'data-sm-field-layer',
          'data-sm-control-row',
          'data-sm-prompt',
          'data-sm-control',
          'data-sm-floated',
          'data-sm-phone-shell',
          'data-sm-multiline'
        ].forEach((attribute) => element.removeAttribute(attribute));
      });
    };

    const closestSharedAncestor = (first, second) => {
      if (!first || !second) return null;

      let element = first;

      while (element) {
        if (element.contains?.(second)) return element;
        element = element.parentElement;
      }

      return null;
    };

    const directChildWithin = (element, container) => {
      if (
        !element ||
        !container ||
        element === container ||
        !container.contains(element)
      ) {
        return null;
      }

      let branch = element;

      while (branch.parentElement && branch.parentElement !== container) {
        branch = branch.parentElement;
      }

      return branch.parentElement === container ? branch : null;
    };

    const normaliseNewsletter = (root) => {
      const dialogSelector = "[role='dialog'], [aria-modal='true']";
      const dialog = root.querySelector(dialogSelector);
      const closeButton =
        dialog?.querySelector(newsletterCloseSelector) || root.querySelector(newsletterCloseSelector);

      /* Inline forms have neither a modal dialog nor a close control. */
      if (!dialog && !closeButton) return;

      const initialScope = dialog || root;
      const form = initialScope.querySelector('form') || root.querySelector('form');
      if (!form) return;

      const shared = closeButton
        ? closestSharedAncestor(form, closeButton)
        : dialog;
      const scope = dialog || shared || root;
      const containerSelectors = [
        "[data-testid='form-container']",
        '#form-container-ref',
        "[data-sizing='form-wrapper']"
      ];
      const candidates = [];

      containerSelectors.forEach((selector) => {
        if (scope.matches?.(selector)) candidates.push(scope);
        scope.querySelectorAll?.(selector).forEach((element) => {
          if (element.contains(form) && !candidates.includes(element)) {
            candidates.push(element);
          }
        });
      });

      const container =
        candidates.find((element) => closeButton && element.contains(closeButton)) ||
        candidates[0] ||
        shared;

      if (!container || !container.contains(form)) return;

      const rootMarker =
        dialog && dialog !== container
          ? dialog
          : container.parentElement && container.parentElement !== root
            ? container.parentElement
            : null;

      const heading = container.querySelector('h2');
      const contentSeed = heading
        ? closestSharedAncestor(form, heading) || form
        : form;
      const content =
        directChildWithin(contentSeed, container) ||
        directChildWithin(form, container) ||
        form.parentElement;

      const explicitImage = container.querySelector(
        "[data-testid='image'], [style*='background-image']"
      );
      const artwork = Array.from(
        container.querySelectorAll('img, picture')
      ).find((element) => !content?.contains(element));
      let imageMedia = explicitImage || artwork;

      if (!imageMedia) {
        imageMedia = Array.from(
          container.querySelectorAll('div, section, figure')
        ).find((element) => {
          if (content?.contains(element) || element.contains(closeButton)) {
            return false;
          }

          try {
            return getComputedStyle(element).backgroundImage !== 'none';
          } catch (error) {
            return false;
          }
        });
      }

      const image = imageMedia
        ? directChildWithin(imageMedia, container) || imageMedia
        : null;

      // Finish background-image discovery before marker writes change layout.
      mark(rootMarker, 'data-sm-newsletter-root');
      mark(container, 'data-sm-newsletter-container');
      if (content && content !== container) mark(content, 'data-sm-newsletter-content');

      if (heading) {
        mark(heading, 'data-sm-newsletter-heading');
        const title = heading.textContent.trim().replace(/\s+/g, ' ').toUpperCase();

        if (
          title === 'JOIN THE SELECT NEWSLETTER' &&
          !heading.hasAttribute('data-sm-newsletter-lines')
        ) {
          const fragment = document.createDocumentFragment();
          ['JOIN THE', 'SELECT', 'NEWSLETTER'].forEach((line) => {
            const span = document.createElement('span');
            span.setAttribute('data-sm-newsletter-line', '');
            span.textContent = line;
            fragment.appendChild(span);
          });
          heading.replaceChildren(fragment);
          mark(heading, 'data-sm-newsletter-lines');
        }
      }

      if (image && image !== content && image !== container) {
        mark(image, 'data-sm-newsletter-image');
        mark(imageMedia, 'data-sm-newsletter-image-media');
        mark(container, 'data-sm-newsletter-has-image');
      } else {
        container.removeAttribute('data-sm-newsletter-has-image');
      }

      if (closeButton) {
        mark(closeButton, 'data-sm-newsletter-close');

        const closeWrapper =
          closeButton.closest("[data-testid='btn-close-wrapper']") ||
          closeButton.parentElement;

        if (closeWrapper && closeWrapper !== container) {
          mark(closeWrapper, 'data-sm-newsletter-close-wrapper');
        }
      }
    };

    const getChoiceTile = (input) => {
      if (!input?.matches?.(choiceInputSelector)) return null;

      const label = input.closest('label');
      const group = label?.parentElement;

      if (!label || !group) return null;

      // Membership is guaranteed by parentElement; only two labels are needed.
      let labels = 0;
      for (const element of group.children) {
        if (element.tagName === 'LABEL' && ++labels === 2) return label;
      }
      return null;
    };

    const normaliseChoice = (input) => {
      const label = getChoiceTile(input);
      if (!label) return;

      mark(label, 'data-sm-choice-tile');
      label.toggleAttribute('data-sm-selected', input.checked);
      mark(input, 'data-sm-choice-control');

      let controlCell = input;

      while (
        controlCell.parentElement &&
        controlCell.parentElement !== label
      ) {
        controlCell = controlCell.parentElement;
      }

      if (controlCell.parentElement !== label) return;

      if (controlCell !== input) {
        mark(controlCell, 'data-sm-choice-control-cell');
      }

      Array.from(label.children).forEach((child) => {
        if (child === controlCell) return;
        mark(child, 'data-sm-choice-copy');
      });
    };

    const normaliseChoices = (root) => {
      if (root.matches?.(choiceInputSelector)) normaliseChoice(root);
      root.querySelectorAll(choiceInputSelector).forEach(normaliseChoice);
    };

    const observeChoices = (root) => {
      if (observedRoots.has(root)) return;
      observedRoots.add(root);

      const syncFromEvent = (event) => {
        const directInput = event.target?.matches?.(choiceInputSelector)
          ? event.target
          : null;
        const labelInput = event.target
          ?.closest?.('label')
          ?.querySelector?.(choiceInputSelector);
        const input = directInput || labelInput;

        if (!input) return;

        /* A radio change also clears its previously selected sibling. */
        const group = input.closest('fieldset');
        normaliseChoices(group);
        queueMicrotask(() => {
          if (root.host.isConnected && root.contains(group)) normaliseChoices(group);
        });
      };

      root.addEventListener('input', syncFromEvent, true);
      root.addEventListener('change', syncFromEvent, true);
      root.addEventListener('click', syncFromEvent, true);

      let normaliseFrame = 0;
      const dirtyChoiceScopes = new Set();
      let newsletterChanged = false;
      const newsletterLayoutSelector = [
        'form', "[role='dialog']", "[aria-modal='true']",
        "[data-testid='form-container']", '#form-container-ref',
        "[data-sizing='form-wrapper']", '[data-sm-newsletter-root]',
        '[data-sm-newsletter-container]', '[data-sm-newsletter-content]',
        '[data-sm-newsletter-image]', '[data-sm-newsletter-image-media]'
      ].join(',');

      const choiceObserver = new MutationObserver((records) => {
        records.forEach((record) => {
          const target = record.target;
          const group = target.closest?.('fieldset');

          if (record.type === 'childList') {
            const addedElements = Array.from(record.addedNodes).filter(
              (node) => node.nodeType === 1
            );
            const hasRemovedElements = Array.from(record.removedNodes).some(
              (node) => node.nodeType === 1
            );
            if (!addedElements.length && !hasRemovedElements) return;

            if (group) dirtyChoiceScopes.add(group);
            else addedElements.forEach((node) => dirtyChoiceScopes.add(node));
            // Validation messages and choice labels inside the existing content
            // do not alter the popup's frame, title, artwork or close control.
            const inNewsletterContent = target.closest?.('[data-sm-newsletter-content]');
            const changesNewsletterStructure = [...record.addedNodes, ...record.removedNodes].some(node =>
              node.nodeType === 1 && (node.matches(newsletterStructureSelector) || node.querySelector(newsletterStructureSelector))
            );
            if (!inNewsletterContent || changesNewsletterStructure) newsletterChanged = true;
          } else {
            if (group) dirtyChoiceScopes.add(group);
            /* Typing changes input/label classes, but not popup geometry. */
            if (record.attributeName === 'class' && target.matches(newsletterLayoutSelector)) {
              newsletterChanged = true;
            }
          }
        });

        if (!dirtyChoiceScopes.size && !newsletterChanged) return;
        if (normaliseFrame) return;
        normaliseFrame = requestAnimationFrame(() => {
          normaliseFrame = 0;
          const scopes = Array.from(dirtyChoiceScopes);
          const updateNewsletter = newsletterChanged;
          dirtyChoiceScopes.clear();
          newsletterChanged = false;
          if (!root.host.isConnected) return;

          if (updateNewsletter) normaliseNewsletter(root);
          scopes.forEach((scope) => {
            if (!root.contains(scope)) return;
            if (scopes.some((other) => other !== scope && other.contains(scope))) return;
            normaliseChoices(scope);
          });
        });
      });

      choiceObserver.observe(root, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['checked', 'class', 'aria-checked']
      });
    };

    const pendingHosts = new Map();
    let mountTimer;
    const checkPendingHosts = () => {
      pendingHosts.forEach((deadline, host) => {
        if (!host.isConnected || Date.now() > deadline) pendingHosts.delete(host);
        else styleFormsHost(host);
      });
      mountTimer = pendingHosts.size ? window.setTimeout(checkPendingHosts, 250) : null;
    };

    const styleFormsHost = (host) => {
      if (!host?.matches?.(hostSelector)) return;

      const root = host.shadowRoot;
      if (!root) {
        if (!pendingHosts.has(host)) pendingHosts.set(host, Date.now() + 20000);
        if (!mountTimer) mountTimer = window.setTimeout(checkPendingHosts, 250);
        return;
      }
      pendingHosts.delete(host);
      prepareSheet();

      if (!styledRoots.has(root)) {
        clearLegacyMarkers(root);
        root
          .querySelectorAll('style[data-sm-luxury-forms]')
          .forEach((style) => style.remove());
        styledRoots.add(root);
      }

      if (luxurySheet && 'adoptedStyleSheets' in root) {
        try {
          const sheets = Array.from(root.adoptedStyleSheets || []);
          const luxuryIsLast = sheets.at(-1) === luxurySheet;
          const luxuryCount = sheets.filter(
            (sheet) => sheet === luxurySheet
          ).length;

          if (!luxuryIsLast || luxuryCount !== 1) {
            root.adoptedStyleSheets = [
              ...sheets.filter((sheet) => sheet !== luxurySheet),
              luxurySheet
            ];
          }
        } catch (error) {
          /* Use a normal style element below. */
        }
      }

      if (!luxurySheet || !root.adoptedStyleSheets?.includes(luxurySheet)) {
        let style = root.querySelector(
          "style[data-sm-luxury-forms='v11']"
        );

        if (!style) {
          style = document.createElement('style');
          style.dataset.smLuxuryForms = 'v11';
          style.textContent = luxuryCss;
          root.appendChild(style);
        }

        const styles = Array.from(root.querySelectorAll('style'));
        if (styles.at(-1) !== style) root.appendChild(style);
      }

      normaliseNewsletter(root);
      normaliseChoices(root);
      observeChoices(root);
    };

    const scanNode = (node = document) => {
      if (!node) return;

      if (node.nodeType === 1 && node.matches?.(hostSelector)) {
        styleFormsHost(node);
      }

      node.querySelectorAll?.(hostSelector).forEach(styleFormsHost);
    };

    // App renders can add both a wrapper and its descendants in one batch.
    // Scan each surviving subtree once, while keeping initial form styling
    // synchronous and retaining support for later popup/section mounts.
    const addedScopes = new Set();
    let hostScanFrame = 0;
    const observer = new MutationObserver((records) => {
      records.forEach((record) => {
        record.addedNodes.forEach((node) => {
          if (node.nodeType === 1) addedScopes.add(node);
        });
      });
      if (!addedScopes.size || hostScanFrame) return;
      hostScanFrame = requestAnimationFrame(() => {
        hostScanFrame = 0;
        const scopes = Array.from(addedScopes).filter(node => node.isConnected);
        addedScopes.clear();
        const scopeSet = new Set(scopes);
        scopes.forEach(node => {
          for (let parent = node.parentElement; parent; parent = parent.parentElement) {
            if (scopeSet.has(parent)) return;
          }
          scanNode(node);
        });
      });
    });

    scanNode(document);

    if (document.documentElement) {
      observer.observe(document.documentElement, {
        childList: true,
        subtree: true
      });
    }

    ['shopify-forms-embed', 'form-embed'].forEach((name) => {
      // A definition can replace a host's own sheets or native choice state.
      // Preserve that repair, without reprocessing the other host type too.
      customElements.whenDefined(name).then(() => {
        document.querySelectorAll(name).forEach(styleFormsHost);
      });
    });

    document.addEventListener('shopify:section:load', event => scanNode(event.target));
    window.addEventListener('pageshow', () => scanNode(document));
  })();
